import axios, { AxiosPromise } from 'axios';
import { TramiteProtocolo } from 'itbi-cidadao/src/types';

export const updateParecerRequerente = (
  params: string,
  tramite: TramiteProtocolo
): AxiosPromise<TramiteProtocolo> => {
  return axios.put(`/gateway/tramites/parecer-requerente?${params}`, tramite);
};
